import { useEffect } from "react";
import { Container, Skeleton } from "@/components/atoms";
import { ClientsActionMenu, ClientsImportPanel, ClientsModals, PageHeaderV2 } from "@/components/organisms";
import { ClientsTable } from "@/components/organisms/Clients/ClientsTable";
import { useGetClientsParams } from "@/components/organisms/Clients/useGetClientsParams";
import { useGetClientsQuery } from "@/redux/apis/client/clientApi";
import { useAppSelector } from "@/redux/hooks";
import { clientsSelector } from "@/redux/slices/client/selectors";
import { OnboardingClientsSection } from "@/redux/slices/onboarding/types";
import { selectCameFromQuickSetup, selectLastClickedSection } from "@/redux/slices/quickSetup/selectors";
import { useClientsContext } from "./context";
import { ClientsFilters } from "./features/Filters/ClientsFilters";

export const ClientsPanel = () => {
  const { step, setStep } = useClientsContext();
  const { params } = useGetClientsParams();
  const { isFetching, refetch } = useGetClientsQuery(params, { refetchOnMountOrArgChange: true });
  const clients = useAppSelector(clientsSelector);
  const cameFromQuickSetup = useAppSelector(selectCameFromQuickSetup);
  const lastClickedSection = useAppSelector(selectLastClickedSection);

  useEffect(() => {
    if (cameFromQuickSetup && lastClickedSection === OnboardingClientsSection.UPLOAD_CLIENTS) {
      setStep("import");
    }
  }, [cameFromQuickSetup, lastClickedSection, setStep]);

  return (
    <Container className="mb-12 flex w-full flex-1 flex-col">
      <PageHeaderV2 name="Clients" skipCrumbs={1}>
        <ClientsActionMenu />
      </PageHeaderV2>
      <ClientsFilters.ActiveFilters className="mt-2" />
      {isFetching ? (
        <Skeleton />
      ) : (
        <div className="mt-2">
          <ClientsTable items={clients} />
          <ClientsTable.Pagination />
        </div>
      )}
      <ClientsModals />
      <ClientsImportPanel open={step === "import"} onClose={() => setStep(undefined)} refetchClients={() => refetch()} />
    </Container>
  );
};
